<template>
  <div class="gender-page">
    <!-- Header Section -->
    <AppHeader 
      header-text="Drivers in your state can save up to $600/year"
      button-text="FREE CALL"
    />

    <!-- Progress Bar -->
    <div class="progress-container">
      <div class="progress-bar">
        <div class="progress-fill"></div>
      </div>
    </div>

    <!-- Navigation -->
    <div class="navigation">
      <div class="container">
        <button class="back-btn" @click="goBack">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Previous Question
        </button>
      </div>
    </div>

    <!-- Gender Section -->
    <section class="gender-section">
      <div class="container">
        <div class="gender-content">
          <PageTitle title="Gender" />
          
          <div class="gender-options">
            <button 
              :class="['gender-button', { 'selected': selectedGender === 'male' }]"
              @click="selectGender('male')"
            >
              Male
            </button>
            <button 
              :class="['gender-button', { 'selected': selectedGender === 'female' }]"
              @click="selectGender('female')"
            >
              Female
            </button>
            <button 
              :class="['gender-button', { 'selected': selectedGender === 'not-specified' }]"
              @click="selectGender('not-specified')"
            >
              Not Specified
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer Links -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import PageTitle from '@/components/PageTitle.vue'
import { submitDataAndLog } from '@/utils/localStorage'

export default {
  name: 'GenderPage',
  components: {
    AppHeader,
    AppFooter,
    PageTitle
  },
  data() {
    return {
      selectedGender: null,
      userQuoteData: null
    }
  },
  mounted() {
    this.loadUserData()
  },
  methods: {
    loadUserData() {
      const storedData = localStorage.getItem('quoteData')
      if (storedData) {
        try {
          this.userQuoteData = JSON.parse(storedData)
          // 加载之前选择的性别（如果有的话）
          // 检查是否是添加驾驶员模式
          let genderValue
          if (this.userQuoteData.adding_driver && this.userQuoteData.temp_driver) {
            genderValue = this.userQuoteData.temp_driver.gender
          } else {
            genderValue = this.userQuoteData.gender
          }
          
          if (genderValue !== undefined) {
            // 将数字值映射回文本显示：2=Male, 1=Female, 0=其他
            if (genderValue === '2') {
              this.selectedGender = 'Male'
            } else if (genderValue === '1') {
              this.selectedGender = 'Female'
            } else {
              this.selectedGender = null // 如果是0或其他值，不预选
            }
          }
        } catch (error) {
          console.error('Error parsing stored data:', error)
          this.$router.push('/')
        }
      } else {
        // 如果没有数据，跳转回首页
        this.$router.push('/')
      }
    },
    
    saveUserData() {
      localStorage.setItem('quoteData', JSON.stringify(this.userQuoteData))
    },
    
    async selectGender(gender) {
      this.selectedGender = gender
      
      // 映射gender值：Male=2, Female=1, 其他=0
      let genderValue
      if (gender === 'Male') {
        genderValue = '2'
      } else if (gender === 'Female') {
        genderValue = '1'
      } else {
        genderValue = '0'
      }
      
      // 检查是否是添加驾驶员模式
      if (this.userQuoteData.adding_driver && this.userQuoteData.temp_driver) {
        // 添加驾驶员模式：更新临时驾驶员数据
        this.userQuoteData.temp_driver.gender = genderValue
        console.log('Selected gender for additional driver:', `${gender} -> ${genderValue}`)
      } else {
        // 主驾驶员模式：更新主驾驶员数据
        this.userQuoteData.gender = genderValue
        console.log('Selected gender for primary driver:', `${gender} -> ${genderValue}`)
      }
      
      this.saveUserData()
      
      // 提交数据并记录页面提交事件
      await submitDataAndLog('gender')
      // 跳转到婚姻状况页面
      this.$router.push('/married')
    },
    
    goBack() {
      this.$router.push('/insurance')
    }
  }
}
</script>

<style scoped>
/* Page Layout */
.gender-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}


/* Navigation */
.navigation {
  padding: 1rem 0;
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  color: #999;
  font-size: 0.9rem;
  cursor: pointer;
  transition: color 0.3s ease;
}

.back-btn:hover {
  color: #666;
}

/* Gender Section */
.gender-section {
  padding: 2rem 0 4rem;
  background: #fff;
  flex: 1;
}

.gender-content {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
}

.gender-options {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.gender-button {
  padding: 1.5rem 2.5rem;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  background: #fff;
  color: #007bff;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 140px;
  min-height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.gender-button:hover {
  border-color: #007bff;
  background: #f8f9fa;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,123,255,0.15);
}

.gender-button.selected {
  border-color: #007bff;
  background: #007bff;
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,123,255,0.3);
}

/* Mobile Layout */
@media (max-width: 768px) {
  .gender-content {
    padding: 0 1rem;
  }

  .gender-options {
    flex-direction: column;
    gap: 1rem;
  }

  .gender-button {
    padding: 1.2rem 2rem;
    font-size: 1rem;
    min-width: 250px;
    min-height: 60px;
  }

  .gender-section {
    padding: 1.5rem 0 2rem;
  }
}

@media (max-width: 480px) {
  .gender-options {
    gap: 0.8rem;
    padding: 0 1rem;
  }

  .gender-button {
    padding: 1rem 1.5rem;
    font-size: 0.95rem;
    min-width: 200px;
    min-height: 55px;
  }

  .gender-section {
    padding: 1rem 0;
  }
}
</style>
